import React, { 
    // Fragment, 
    useEffect, useRef, useState } from "react";
import {
    Box,
    CircularProgress,
    Grid,
    // CardMedia,
    Typography,
    Container,
} from "@mui/material";
import { useParams } from "react-router-dom";
import Colors from "assets/Style/Colors";
import { ErrorToaster } from "components/Toaster";
import { PrimaryButton } from "components/Buttons";
import { CommaSeparator, handleExportWithComponent } from "utils";
import VehiclePaymentServices from "services/VehiclePayment";
import LogoImage from "assets/Images/header_voucher.svg";
import { useReactToPrint } from "react-to-print";
import {
    FontFamily,
    // Images,
    InvoiceGlobal,
    InvoiceLocation,
    InvoiceMail,
    InvoicePhone,
} from "assets";
import { makeStyles } from "@mui/styles";
import moment from "moment";
import CurrencyServices from "services/Currency";
import { QRCodeCanvas } from "qrcode.react";
import { PDFExport } from "@progress/kendo-react-pdf";
import { useAuth } from "context/UseContext";
import { Print } from "@mui/icons-material";


const useStyle = makeStyles({
    headingBg: {
        margin: "32px 0px",
        padding: "12px 0px",
        textAlign: "center",
    },
    heading: {
        color: Colors.white,
        textTransform: "uppercase",
        fontWeight: 300,
        fontFamily: FontFamily.openSans,
    },
    text: {
        color: Colors.smokeyGrey,
        fontWeight: 300,
        fontFamily: FontFamily.openSans,
    },
    tableCell: {
        backgroundColor: Colors.aliceBlue,
        border: "0.25px solid #D9D9D9",
        "& .MuiTypography-root": {
            padding: "4px 12px",
        },
    },
});

function VehicleInvoice2() {
    const { id } = useParams();
    const contentRef = useRef(null);
    const classes = useStyle();
    const { user } = useAuth();
    const [layoutSelection, setLayoutSelection] = useState({
        text: "A4",
        value: "size-a4",
    });

    const [loader, setLoader] = useState(true);

    // *For Invoice Detail
    const [invoiceDetail, setInvoiceDetail] = useState();

    // *For Currencies
    const [currencyExchangeRate, setCurrencyExchangeRate] = useState();
    const [isContentReady, setIsContentReady] = useState(false);
    

    const handlePrint = useReactToPrint({
        content: () => contentRef.current,
        documentTitle: "Invoice",
        onBeforePrint: () => {
          const content = contentRef.current;
          if (content && isContentReady) {
            content.style.transform = "scale(0.83)";
            content.style.transformOrigin = "top center";
          } else {
            console.warn("contentRef.current is not available in onBeforePrint");
          }
        },
        onAfterPrint: () => {
          try {
            const content = contentRef.current;
            if (content) {
              content.style.transform = "none";
            } else {
              console.warn(
                "contentRef.current is null or undefined in onAfterPrint"
              );
            }
          } catch (error) {
            console.error("Error in onAfterPrint:", error);
          }
        },
      });
    
    // *For Get Invoice Detail
    const getInvoiceDetails = async () => {
        setLoader(true);
        try {
            let params = {
                invoice_id: atob(id),
            };
            const { data } = await VehiclePaymentServices.getInvoicePreview(params);
            setInvoiceDetail(data);
            getCurrencies(data?.invoice?.booking?.currency);
        } catch (error) {
            ErrorToaster(error);
        } finally {
            setLoader(false);
        }
    };

    // *For Get Currencies
    const getCurrencies = async (currency) => {
        try {
            let params = {
                detailed: true,
            };
            const { data } = await CurrencyServices.getCurrenciesPreview(params);
            const rate = data?.currencies.find(
                (e) => e.currency === currency
            )?.conversion_rate;
            setCurrencyExchangeRate(rate);
        } catch (error) {
            ErrorToaster(error);
        }
    };

    useEffect(() => {
        if (id) {
            getInvoiceDetails();
        }
    }, [id]);

    return (
        <Container>
                 {!loader && (
              <Box
                sx={{
                  textAlign: "right",
                  p: 4,
                  alignItems: "center",
                  justifyContent: "flex-end",
                  display: "flex",
                }}
              >
                <PrimaryButton
                  title="Download Invoice"
                  type="button"
                  style={{ backgroundColor: Colors.bluishCyan }}
                  onClick={() => handleExportWithComponent(contentRef)}
                />
                <Box
                  component="div"
                  sx={{
                    display: "inline-block",
                    marginLeft: 2,
                    cursor: "pointer",
                  }}
                  onClick={() => handlePrint()}
                >
                  <Print
                    sx={{
                      height: 30,
                      width: 30,
                      cursor: "pointer",
                      color: Colors.primary,
                    }}
                  />
                </Box>
              </Box>
            )}
            <PDFExport ref={contentRef} fileName="Vehicle Invoice">
              <Box
                sx={{
                  width: "1000px",
                  mx: 4,
                  my: 2,
                  bgcolor: Colors.white,
                  boxShadow: "0px 8px 18px 0px #9B9B9B1A",
                }}
                className={`pdf-page ${layoutSelection.value}`}
              >
                {!loader ? (
                  <Box>
                    <Grid container spacing={0}>
                      <Box
                        sx={{
                          width: { xs: "100%", md: "25%" },
                          "@media print": {
                            width: "25%",
                            flex: "0 0 25%",
                          },
                          marginTop: "5px",
                        }}
                      >
                        <Box
                          component="img"
                          src={LogoImage}
                          alt="Ship Logo"
                          sx={{
                            width: "100%",
                            objectFit: "contain",
                            display: "block",
                            maxHeight: "100px",
                          }}
                        />
                      </Box>

                      {/* Right Contact Info */}
                      <Box
                        sx={{
                          backgroundColor: Colors.green,
                          padding: 2,
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          width: { xs: "100%", md: "71.5%" },
                          marginRight: "3.5%",
                          "@media print": {
                            width: "71.5%",
                            flex: "0 0 71.5%",
                          },
                        }}
                      >
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={6}>
                            <Box
                              sx={{
                                display: "flex",
                                gap: 1,
                                alignItems: "center",
                              }}
                            >
                              <InvoicePhone />
                              <Typography
                                variant="body1"
                                sx={{
                                  color: Colors.whiteSmoke,
                                  fontFamily: FontFamily.openSans,
                                  fontSize: 14,
                                }}
                              >
                                +971 6 510 2000
                              </Typography>
                            </Box>
                          </Grid>

                          <Grid item xs={12} sm={6}>
                            <Box
                              sx={{
                                display: "flex",
                                gap: 1,
                                alignItems: "center",
                              }}
                            >
                              <InvoiceMail />
                              <Typography
                                variant="body1"
                                sx={{
                                  color: Colors.whiteSmoke,
                                  fontFamily: FontFamily.openSans,
                                  fontSize: 14,
                                }}
                              >
                                info@galaxyshipping.com
                              </Typography>
                            </Box>
                          </Grid>

                          <Grid item xs={12} sm={6}>
                            <Box
                              sx={{
                                display: "flex",
                                gap: 1,
                                alignItems: "center",
                              }}
                            >
                              <InvoiceGlobal />
                              <Typography
                                variant="body1"
                                sx={{
                                  color: Colors.whiteSmoke,
                                  fontFamily: FontFamily.openSans,
                                  fontSize: 14,
                                }}
                              >
                                https://galaxyshipping.com
                              </Typography>
                            </Box>
                          </Grid>

                          <Grid item xs={12} sm={6}>
                            <Box
                              sx={{
                                display: "flex",
                                gap: 1,
                                alignItems: "center",
                              }}
                            >
                              <InvoiceLocation />
                              <Typography
                                variant="body1"
                                sx={{
                                  color: Colors.whiteSmoke,
                                  fontFamily: FontFamily.openSans,
                                  fontSize: 14,
                                }}
                              >
                                Ind Area#4 P.O Box 83126, Sharjah, UAE
                              </Typography>
                            </Box>
                          </Grid>
                        </Grid>

                      </Box>
                    </Grid>

                    <Box
                      sx={{
                        my: 5,
                        position: "relative",
                        bgcolor: Colors.primary,
                        width: 1,
                        height: "12px",
                      }}
                    >
                      <Typography
                        component={"span"}
                        variant="h2"
                        sx={{
                          color: Colors.charcoalGrey,
                          bgcolor: Colors.white,
                          p: 2,
                          letterSpacing: "3px",
                          position: "absolute",
                          right: "90px",
                          top: "-40px",
                        }}
                      >
                        VEHICLE INVOICE
                      </Typography>
                    </Box>
                    <Box sx={{ padding: 4 }}>
                      <Box
                        sx={{
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          overflow: "hidden",
                          width: "100%",
                          fontSize: "13px",
                          marginBottom: "10px",
                        }}
                      >
                        <Box
                          sx={{
                            position: "relative",
                            display: "flex",
                            height: 40,
                            width: "100%",
                          }}
                        >
                          {/* Light Green Triangle that fills the clipped corner */}
                          <Box
                            sx={{
                              position: "absolute",
                              top: 0,
                              left: "calc(50% - 15%)", // aligns with the diagonal cut start
                              width: "15%",
                              height: "100%",
                              backgroundColor: "#6cc04a",
                              clipPath: "polygon(100% 0, 100% 100%, 0% 100%)", // triangle shape
                              zIndex: 0,
                            }}
                          />

                          {/* Left Header with diagonal cut */}
                          <Box
                            sx={{
                              width: "50%",
                              backgroundColor: "#0a5b2d",
                              clipPath: "polygon(0 0, 100% 0, 85% 100%, 0% 100%)",
                              color: "#fff",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontWeight: "bold",
                              fontSize: "20px",
                              zIndex: 1,
                            }}
                          >
                            Invoice to
                          </Box>

                          {/* Right Header */}
                          <Box
                            sx={{
                              width: "50%",
                              backgroundColor: "#6cc04a",
                              color: "#fff",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontWeight: "bold",
                              fontSize: "20px",
                              zIndex: 1,
                            }}
                          >
                            Vehicle Details
                          </Box>
                        </Box>

                        {/* Body */}
                        <Grid container>
                          {/* Customer Details */}
                          <Grid item xs={6} sx={{ px: 2, py: 1.5 }}>
                            <Grid container sx={{ padding: "10px" }}>
                              <Grid item xs={5}>
                                <Typography variant="body1">Customer ID:</Typography>
                              </Grid>
                              <Grid item xs={7}>
                                <Typography
                                  variant="body1"
                                  sx={{ fontFamily: FontFamily.NunitoRegular }}
                                >
                                  {invoiceDetail?.invoice?.booking?.customer?.id ?? "-"}{" "}
                                </Typography>
                              </Grid>
                              <Grid item xs={5}>
                                <Typography variant="body1">
                                  Customer Name:
                                </Typography>
                              </Grid>
                              <Grid item xs={7}>
                                <Typography
                                  variant="body1"
                                  sx={{ fontFamily: FontFamily.NunitoRegular }}
                                >
                                  {invoiceDetail?.invoice?.booking?.customer?.name ?? "-"}
                                </Typography>
                              </Grid>
                              <Grid item xs={5}>
                                <Typography variant="body1">Received By:</Typography>
                              </Grid>
                              <Grid item xs={7}>
                                <Typography
                                  variant="body1"
                                  sx={{ fontFamily: FontFamily.NunitoRegular }}
                                >
                                  {invoiceDetail?.pay_history?.rows?.[0]?.payment?.user?.name ?? '-'}
                                </Typography>
                              </Grid>
                            </Grid>
                          </Grid>

                          {/* Divider */}
                          <Box
                            sx={{
                              width: "1px",
                              backgroundColor: "#ccc",
                              height: "auto",
                            }}
                          />

                          {/* Vehicle Details */}
                          <Grid item xs={5.9} sx={{ px: 2, py: 1.5 }}>
                            <Grid container spacing={1}>
                              {/* Left column */}
                              <Grid item xs={6}>
                                <Grid container spacing={0.5}>

                                  <Grid item xs={5}>
                                    <Typography
                                      sx={{ fontSize: "16px" }}
                                      variant="body1"
                                    >
                                      Buyer ID :
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={7}>
                                    <Typography
                                      variant="body1"
                                      sx={{
                                        fontSize: "16px",
                                        fontFamily: FontFamily.NunitoRegular,
                                      }}
                                    >
                                      {invoiceDetail?.invoice?.booking?.buyer?.name
                                        ? invoiceDetail?.invoice?.booking?.buyer?.name
                                          .split("-")
                                          .pop()
                                        : "-"}

                                    </Typography>
                                  </Grid>
                                  <Grid item xs={5}>
                                    <Typography
                                      variant="body1"
                                      sx={{ fontSize: "16px" }}
                                    >
                                      Purchased:
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={7}>
                                    <Typography
                                      variant="body1"
                                      sx={{
                                        fontSize: "16px",
                                        fontFamily: FontFamily.NunitoRegular,
                                      }}
                                    >
                                      {moment(
                                        invoiceDetail?.invoice?.booking?.purchase_date
                                      ).format("DD-MM-YYYY")}
                                    </Typography>
                                  </Grid>


                                  <Grid item xs={5}>
                                    <Typography
                                      sx={{ fontSize: "16px" }}
                                      variant="body1"
                                    >
                                      VIN:
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={7}>
                                    <Typography
                                      variant="body1"
                                      sx={{
                                        fontSize: "16px",
                                        fontFamily: FontFamily.NunitoRegular,
                                      }}
                                    >
                                      {invoiceDetail?.invoice?.booking?.vin}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>

                              {/* Right column */}
                              <Grid item xs={6}>
                                <Grid container spacing={0.5}>
                                  <Grid item xs={5}>
                                    <Typography
                                      sx={{ fontSize: "16px" }}
                                      variant="body1"
                                    >
                                      LOT:
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={7}>
                                    <Typography
                                      variant="body1"
                                      sx={{
                                        fontSize: "16px",
                                        fontFamily: FontFamily.NunitoRegular,
                                      }}
                                    >
                                      {invoiceDetail?.invoice?.booking?.lot_number ?? '-'}
                                    </Typography>
                                  </Grid>

                                  <Grid item xs={5}>
                                    <Typography
                                      sx={{ fontSize: "16px" }}
                                      variant="body1"
                                    >
                                      Auctioneer:
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={7}>
                                    <Typography
                                      variant="body1"
                                      sx={{
                                        fontSize: "16px",
                                        fontFamily: FontFamily.NunitoRegular,
                                        ml: "3px"
                                      }}
                                    >
                                      {invoiceDetail?.invoice?.booking?.auctioneer ?? "-"}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>

                              {/* Full-width row for Make/Model/Color */}
                              <Grid item xs={12}>
                                <Grid container spacing={0.5}>
                                  <Grid item xs={4.4}>
                                    <Typography
                                      sx={{ fontSize: "16px" }}
                                      variant="body1"
                                    >
                                      Model/Make/Color:
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={7.6}>
                                    <Typography
                                      variant="body1"
                                      sx={{
                                        fontSize: "16px",
                                        fontFamily: FontFamily.NunitoRegular,
                                      }}
                                    >
                                      {invoiceDetail?.invoice?.booking?.veh_model?.name ?? "-"}{" "}
                                      -{" "}
                                      {invoiceDetail?.invoice?.booking?.veh_make?.name ?? "-"}{" "}
                                      - {invoiceDetail?.invoice?.booking?.color ?? "-"}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Box>

                      <Grid container spacing={2} justifyContent="space-between">
                        {/* Left Side - Invoice To Section */}
                        <Grid item xs={12} sm={6}>


                          <Grid
                            container
                            sx={{ border: "1px solid #ddd", marginTop: "10px" }}
                          >
                            <Grid item xs={12}>
                              <Typography
                                variant="h6"
                                sx={{
                                  fontFamily: "Helvetica",
                                  textAlign: "center",
                                  fontWeight: "bold",
                                  padding: "8px",
                                }}
                              >
                                Commercial
                              </Typography>
                            </Grid>
                            <Grid item xs={12}>
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  width: "100%",
                                }}
                              >
                                <Box sx={{ overflowX: "auto", maxWidth: "100%" }}>
                                  <table
                                    style={{
                                      width: "100%",
                                      borderCollapse: "collapse",
                                      margin: 0,
                                      padding: 0,
                                      tableLayout: "fixed",
                                    }}
                                  >
                                    <thead>
                                      <tr
                                        style={{
                                          background:
                                            "linear-gradient(90deg, #0C6135 0%, #5BBC0F 100%)",
                                          color: Colors.whiteSmoke,
                                          fontWeight: "bold",
                                        }}
                                      >
                                        <th
                                          style={{
                                            padding: "8px",
                                            textAlign: "center",
                                            borderBottom: "2px solid #ddd",
                                            fontSize: "12px",
                                          }}
                                        >
                                          Particular
                                        </th>
                                        <th
                                          style={{
                                            padding: "8px",
                                            textAlign: "center",
                                            borderBottom: "2px solid #ddd",
                                            fontSize: "12px",
                                          }}
                                        >
                                          USD
                                        </th>
                                        <th
                                          style={{
                                            padding: "8px",
                                            textAlign: "center",
                                            borderBottom: "2px solid #ddd",
                                            fontSize: "12px",
                                          }}
                                        >
                                          AED
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {invoiceDetail?.invoice?.booking?.value >
                                        0 && (
                                          <tr>
                                            <td
                                              style={{
                                                padding: "8px",
                                                borderBottom: "1px solid #ddd",
                                                borderRight: "1px solid #ddd",
                                                borderLeft: "1px solid #ddd",
                                                fontSize: "12px",
                                              }}
                                            >
                                              {"Purchase Price"}
                                            </td>
                                            <td
                                              style={{
                                                padding: "8px",
                                                textAlign: "center",
                                                borderBottom: "1px solid #ddd",
                                                borderRight: "1px solid #ddd",
                                                fontSize: "12px",
                                              }}
                                            >
                                              {CommaSeparator(
                                                parseFloat(
                                                  invoiceDetail?.invoice?.booking?.value
                                                )?.toFixed(2)
                                              )}
                                            </td>
                                            <td
                                              style={{
                                                padding: "8px",
                                                textAlign: "center",
                                                borderBottom: "1px solid #ddd",
                                                borderRight: "1px solid #ddd",
                                                fontSize: "12px",
                                              }}
                                            >
                                              {CommaSeparator(
                                                parseFloat(
                                                  invoiceDetail?.invoice?.booking?.value * 3.675
                                                )?.toFixed(2)
                                              )}
                                            </td>
                                          </tr>
                                        )}
                                      {invoiceDetail?.invoice?.booking?.other_charges > 0 && (
                                        <tr>
                                          <td
                                            style={{
                                              padding: "8px",
                                              borderBottom: "1px solid #ddd",
                                              borderRight: "1px solid #ddd",
                                              borderLeft: "1px solid #ddd",
                                              fontSize: "12px",
                                            }}
                                          >
                                            {"Other Charges"}
                                          </td>
                                          <td
                                            style={{
                                              padding: "8px",
                                              textAlign: "center",
                                              borderBottom: "1px solid #ddd",
                                              borderRight: "1px solid #ddd",
                                              fontSize: "12px",
                                            }}
                                          >
                                            {CommaSeparator(
                                              parseFloat(
                                                invoiceDetail?.invoice?.booking?.other_charges
                                              )?.toFixed(2)
                                            )}
                                          </td>
                                          <td
                                            style={{
                                              padding: "8px",
                                              textAlign: "center",
                                              borderBottom: "1px solid #ddd",
                                              borderRight: "1px solid #ddd",
                                              fontSize: "12px",
                                            }}
                                          >
                                            {CommaSeparator(
                                              parseFloat(
                                                invoiceDetail?.invoice?.booking?.other_charges * 3.675
                                              )?.toFixed(2)
                                            )}
                                          </td>
                                        </tr>
                                      )}
                                      {/* {invoiceDetail?.invoice?.amount > 0 && ( */}
                                      <tr>
                                        <td
                                          style={{
                                            padding: "8px",
                                            borderBottom: "1px solid #ddd",
                                            borderRight: "1px solid #ddd",
                                            borderLeft: "1px solid #ddd",
                                            fontSize: "12px",
                                          }}
                                        >
                                          {"Total Due"}
                                        </td>
                                        <td
                                          style={{
                                            padding: "8px",
                                            textAlign: "center",
                                            borderBottom: "1px solid #ddd",
                                            borderRight: "1px solid #ddd",
                                            fontSize: "12px",
                                          }}
                                        >
                                          {CommaSeparator(
                                            parseFloat(invoiceDetail?.invoice?.amount)?.toFixed(
                                              2
                                            )
                                          )}
                                        </td>
                                        <td
                                          style={{
                                            padding: "8px",
                                            textAlign: "center",
                                            borderBottom: "1px solid #ddd",
                                            borderRight: "1px solid #ddd",
                                            fontSize: "12px",
                                          }}
                                        >
                                          {CommaSeparator(
                                            parseFloat(invoiceDetail?.invoice?.amount * 3.675)?.toFixed(
                                              2
                                            )
                                          )}
                                        </td>
                                      </tr>
                                      {/* )} */}
                                      {/* {invoiceDetail?.costing?.category_a > 0 && ( */}
                                      <tr>
                                        <td
                                          style={{
                                            padding: "8px",
                                            borderBottom: "1px solid #ddd",
                                            borderRight: "1px solid #ddd",
                                            borderLeft: "1px solid #ddd",
                                            fontSize: "12px",
                                          }}
                                        >
                                          {"Paid Amount"}
                                        </td>
                                        <td
                                          style={{
                                            padding: "8px",
                                            textAlign: "center",
                                            borderBottom: "1px solid #ddd",
                                            borderRight: "1px solid #ddd",
                                            fontSize: "12px",
                                          }}
                                        >
                                          {CommaSeparator(
                                            parseFloat(invoiceDetail?.invoice?.paid)?.toFixed(2)
                                          )}
                                        </td>
                                        <td
                                          style={{
                                            padding: "8px",
                                            textAlign: "center",
                                            borderBottom: "1px solid #ddd",
                                            borderRight: "1px solid #ddd",
                                            fontSize: "12px",
                                          }}
                                        >
                                          {CommaSeparator(
                                            parseFloat(invoiceDetail?.invoice?.paid * 3.675)?.toFixed(2)
                                          )}
                                        </td>
                                      </tr>
                                      {/* )} */}
                                      {/* {invoiceDetail?.costing?.broker_fee > 0 && ( */}
                                      <tr>
                                        <td
                                          style={{
                                            padding: "8px",
                                            borderBottom: "1px solid #ddd",
                                            borderRight: "1px solid #ddd",
                                            borderLeft: "1px solid #ddd",
                                            fontSize: "12px",
                                          }}
                                        >
                                          {"Balance Due"}
                                        </td>
                                        <td
                                          style={{
                                            padding: "8px",
                                            textAlign: "center",
                                            borderBottom: "1px solid #ddd",
                                            borderRight: "1px solid #ddd",
                                            fontSize: "12px",
                                          }}
                                        >
                                          {CommaSeparator(
                                            parseFloat(
                                              invoiceDetail?.invoice?.balance
                                            )?.toFixed(2)
                                          )}
                                        </td>
                                        <td
                                          style={{
                                            padding: "8px",
                                            textAlign: "center",
                                            borderBottom: "1px solid #ddd",
                                            borderRight: "1px solid #ddd",
                                            fontSize: "12px",
                                          }}
                                        >
                                          {CommaSeparator(
                                            parseFloat(
                                              invoiceDetail?.invoice?.balance * 3.675
                                            )?.toFixed(2)
                                          )}
                                        </td>
                                      </tr>
                                      {/* )} */}

                                    </tbody>
                                  </table>
                                </Box>
                              </Box>
                            </Grid>
                          </Grid>

                          <Grid
                            container
                            spacing={0.5}
                            sx={{ border: "1px solid #ddd", marginTop: "10px" }}
                          >
                            <Grid item xs={12}>
                              <Typography
                                variant="h6"
                                sx={{
                                  fontFamily: "Helvetica",
                                  textAlign: "center",
                                  fontWeight: "bold",
                                  padding: "8px",
                                }}
                              >
                                Payment History
                              </Typography>
                            </Grid>
                            <Grid md={12} sx={{ paddingLeft: 0 }}>
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  width: "100%",
                                }}
                              >
                                <Box
                                  sx={{
                                    overflowX: "auto",
                                    maxWidth: "100%",
                                    paddingLeft: 0,
                                    marginLeft: 0,
                                  }}
                                >
                                  <table
                                    style={{
                                      width: "100%",
                                      borderCollapse: "collapse",
                                      margin: 0,
                                      padding: 0,
                                      tableLayout: "fixed",
                                    }}
                                  >
                                    <thead>
                                      <tr
                                        style={{
                                          background: Colors.green,
                                          color: Colors.whiteSmoke,
                                          fontWeight: "bold",
                                        }}
                                      >

                                        <th
                                          style={{
                                            padding: "8px",
                                            textAlign: "left",
                                            borderBottom: "2px solid #ddd",
                                            fontSize: "12px",
                                            textAlign: "center",
                                          }}
                                        >
                                          Paid on
                                        </th>

                                        <th
                                          style={{
                                            padding: "8px",
                                            textAlign: "left",
                                            borderBottom: "2px solid #ddd",
                                            fontSize: "12px",
                                            textAlign: "center",
                                          }}
                                        >
                                          Mode
                                        </th>
                                        <th
                                          style={{
                                            padding: "8px",
                                            textAlign: "left",
                                            borderBottom: "2px solid #ddd",
                                            fontSize: "12px",
                                            textAlign: "center",
                                          }}
                                        >
                                          USD
                                        </th>
                                        <th
                                          style={{
                                            padding: "8px",
                                            textAlign: "left",
                                            borderBottom: "2px solid #ddd",
                                            whiteSpace: "pre-line",
                                            fontSize: "12px",
                                            textAlign: "center",
                                          }}
                                        >
                                          AED
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>

                                      {invoiceDetail?.pay_history?.rows.map((detail, index) => (
                                        <tr key={index}>

                                          <td
                                            style={{
                                              padding: "8px",
                                              borderBottom: "1px solid #ddd",
                                              borderRight: "1px solid #ddd",
                                              fontSize: "12px",
                                              textAlign: "center",
                                            }}
                                          >
                                            {moment(detail?.payment?.payment_date).format(
                                              "D-M-YY"
                                            )}
                                          </td>
                                          <td
                                            style={{
                                              padding: "8px",
                                              borderBottom: "1px solid #ddd",
                                              borderRight: "1px solid #ddd",
                                              fontSize: "12px",
                                              textAlign: "center",
                                            }}
                                          >
                                            {detail?.payment?.payment_medium === "vault"
                                              ? "Wallet"
                                              : detail?.payment?.payment_medium}
                                          </td>
                                          <td
                                            style={{
                                              padding: "8px",
                                              borderBottom: "1px solid #ddd",
                                              borderRight: "1px solid #ddd",
                                              fontSize: "12px",
                                              textAlign: "center",
                                            }}
                                          >
                                            {CommaSeparator(
                                              parseFloat(detail?.amount)?.toFixed(2)
                                            ) || "00"}
                                          </td>
                                          <td
                                            style={{
                                              padding: "8px",
                                              borderBottom: "1px solid #ddd",
                                              borderRight: "1px solid #ddd",
                                              fontSize: "12px",
                                              textAlign: "center",
                                            }}
                                          >
                                            {CommaSeparator(
                                              parseFloat(
                                                detail?.amount_aed
                                              )?.toFixed(2)
                                            ) || "00"}
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </Box>
                              </Box>
                            </Grid>
                          </Grid>


                          <Grid item xs={12} mt={3}>
                            <Typography
                              variant="body1"
                              sx={{
                                color: "black",
                                fontFamily: FontFamily.NunitoRegular,
                                fontWeight: "bold",
                                mb:"10px",
                                color:"#0C6135",
                              }}
                            >
                              PLEASE READ CAREFULLY THE TERMS & CONDITIONS:
                            </Typography>
                            <Box
                              sx={{
                                fontWeight: 500,
                                fontSize: "12px",
                              }}
                            >
                              <Typography
                                variant="body2"
                                sx={{ mb: 1, fontFamily: FontFamily.NunitoRegular }}
                              >
                                1- I've clearly informed and the make the understand all the vehicle information, amount, charges and rates.
                              </Typography>
                              <Typography
                                variant="body2"
                                sx={{ mb: 1, fontFamily: FontFamily.NunitoRegular }}
                              >
                                2- Kindly pay the due amount within 3 business days from the purchase date to avoid the Late Payment and Storages that will be charged once vehicle arrived to final destination (Further, If there are some special annousment/memo ignore this and follow that).
                              </Typography>{" "}
                              <Typography
                                variant="body2"
                                sx={{ mb: 1, fontFamily: FontFamily.NunitoRegular }}
                              >
                                3- If vehicle got relisted, the relist charges customer has to pay within 3 days otherwise 15% Penalty will applied after 3 days as issued memo on 9/Jun/2022.
                              </Typography>
                              <Typography
                                variant="body2"
                                sx={{ mb: 1, fontFamily: FontFamily.NunitoRegular }}
                              >
                                4- Galaxy Customer care department will inform you about the latest updates about rates and charges through WhatsApp and emails.
                              </Typography>

                            </Box>
                          </Grid>



                        </Grid>

                        {/* Right Side - Hello Text */}
                        <Grid item xs={12} sm={6}>
                          <Grid
                            container
                            // spacing={0.5}
                            sx={{ border: "1px solid #ddd", marginTop: "10px" }}
                          >
                            <Grid item xs={12}>
                              <Typography
                                variant="h6"
                                sx={{
                                  fontFamily: "Helvetica",
                                  textAlign: "center",
                                  fontWeight: "bold",
                                  padding: "8px",
                                  background:
                                    "linear-gradient(90deg, #0C6135 0%, #5BBC0F 100%)",
                                  color: Colors.whiteSmoke,
                                  fontWeight: "bold",
                                }}
                              >
                                Invoice Details
                              </Typography>
                            </Grid>
                            <Grid item xs={12} sx={{ px: 2, py: 1.5 }}>
                            <Grid container sx={{ padding: "10px" }}>
                              <Grid item xs={6}>
                                <Typography variant="body1">Invoice no.</Typography>
                              </Grid>
                              <Grid item xs={6}>
                                <Typography
                                  variant="body1"
                                  sx={{ fontFamily: FontFamily.NunitoRegular }}
                                >
                                GVI-{invoiceDetail?.invoice?.id}

                                </Typography>
                              </Grid>
                              <Grid item xs={6}>
                                <Typography variant="body1">
                                  Booking no.
                                </Typography>
                              </Grid>
                              <Grid item xs={6}>
                                <Typography
                                  variant="body1"
                                  sx={{ fontFamily: FontFamily.NunitoRegular }}
                                >
                                GBR-{invoiceDetail?.invoice?.booking?.id}
                                </Typography>
                              </Grid>
                              <Grid item xs={6}>
                                <Typography variant="body1">Invoice on:</Typography>
                              </Grid>
                              <Grid item xs={6}>
                                <Typography
                                  variant="body1"
                                  sx={{ fontFamily: FontFamily.NunitoRegular }}
                                >
                                   {moment(invoiceDetail?.invoice?.created_at).format(
                                  "DD-MMM-YYYY hh:mm"
                                )}
                                </Typography>
                              </Grid>

                              <Grid item xs={6}>
                                <Typography variant="body1">Creation on:</Typography>
                              </Grid>
                              <Grid item xs={6}>
                                <Typography
                                  variant="body1"
                                  sx={{ fontFamily: FontFamily.NunitoRegular }}
                                >
                                   {moment(
                                  invoiceDetail?.invoice?.booking?.created_at
                                ).format("DD-MMM-YYYY hh:mm")}
                                </Typography>
                              </Grid>
                              <Grid item xs={6}>
                                <Typography variant="body1">Last Updated on:</Typography>
                              </Grid>
                              <Grid item xs={6}>
                                <Typography
                                  variant="body1"
                                  sx={{ fontFamily: FontFamily.NunitoRegular }}
                                >
                                   {moment(invoiceDetail?.invoice?.updated_at).format(
                                  "DD-MMM-YYYY hh:mm"
                                )}
                                </Typography>
                              </Grid>
                              <Grid item xs={6}>
                                <Typography variant="body1">Due on:</Typography>
                              </Grid>
                              <Grid item xs={6}>
                                <Typography
                                  variant="body1"
                                  sx={{ fontFamily: FontFamily.NunitoRegular }}
                                >
                                  {moment(invoiceDetail?.invoice?.created_at)
                                  .add(3, "days")
                                  .format("DD-MMM-YYYY hh:mm")}
                                </Typography>
                              </Grid>
                              <Grid item xs={6}>
                                <Typography variant="body1">Past Due Days:</Typography>
                              </Grid>
                              <Grid item xs={6}>
                                <Typography
                                  variant="body1"
                                  sx={{ fontFamily: FontFamily.NunitoRegular }}
                                >
                                  {invoiceDetail?.balance == 0
                                  ? moment(invoiceDetail?.invoice?.created_at).diff(
                                    moment(invoiceDetail?.invoice?.updated_at)
                                  ) < 0
                                    ? 0
                                    : moment(invoiceDetail?.invoice?.created_at).diff(
                                      moment(invoiceDetail?.invoice?.updated_at)
                                    )
                                  : moment().diff(
                                    moment(invoiceDetail?.invoice?.created_at).add(
                                      2,
                                      "days"
                                    ),
                                    "days"
                                  ) < 0
                                    ? 0
                                    : moment().diff(
                                      moment(invoiceDetail?.invoice?.created_at).add(
                                        2,
                                        "days"
                                      ),
                                      "days"
                                    )}
                                </Typography>
                              </Grid>
                            </Grid>
                          </Grid>



                          </Grid>


                          <Grid
                            container
                            sx={{ border: "1px solid #ddd", marginTop: "10px" }}
                          >
                            <Grid item xs={12} bgcolor="#F8F8F8">
                              <Typography
                                sx={{
                                  fontFamily: "Helvetica",
                                  fontWeight: 700,
                                  padding: "10px",
                                  fontSize: "18px",
                                  color: "#0C6135"
                                }}
                              >
                                Comment
                              </Typography>
                            </Grid>
                            <Grid item xs={12} bgcolor="#F8F8F8">
                              <Typography
                                sx={{
                                  fontFamily: "Helvetica",
                                  fontWeight: 700,
                                  padding: "10px",
                                  fontSize: "14px",
                                }}
                              >
                                {invoiceDetail?.pay_history?.rows
                              ?.map((item) => item?.payment?.comments)
                              .filter((comment) => comment)
                              .sort((a, b) => a.localeCompare(b))
                              .join(", ")}
                              </Typography>
                            </Grid>

                          </Grid>

                          <Typography sx={{
                            fontFamily: "Helvetica",
                            fontWeight: 700,
                            padding: "10px",
                            fontSize: "16px",
                            color: "#FE2E1B",
                            marginTop:"12px",
                          }}>
                            For complaints, Please whatsapp @ +4917663203237
                          </Typography>



                          <Grid item xs={12} mt={3}>
                            <Box
                              sx={{
                                height: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-end",
                              }}
                            >
                              <QRCodeCanvas
                                value={
                                  window.location.origin +
                                  `/vehicle-invoice-preview-2/${btoa(id)}`
                                }
                              />
                            </Box>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Box>

                    <Box sx={{ pl: 4, pr: 3, py: 1, bgcolor: Colors.primary, mt: 4 }}>
                      <Typography
                        variant="caption"
                        sx={{ color: Colors.white, fontFamily: FontFamily.openSans }}
                      >
                        Customer care Contact: Mohammed husni - +971523195682 (Arabic
                        & English ) Ardamehr Shoev - +971545836028 (English ,Arabic,
                        Tajik & Farsi)
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{ color: Colors.white, fontFamily: FontFamily.openSans }}
                      >
                        Ravin abdul kareem - +971528293801 (Kurdish , Arabic &
                        English) Magsat Gylyjov - +97158666403 (Turken , Russian &
                        English)
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{ color: Colors.white, fontFamily: FontFamily.openSans }}
                      >
                        Ind Area#4 P.O Box 83126, Sharjah, UAE.
                      </Typography>
                    </Box>
                  </Box>
                ) : (
                  <Box sx={{ textAlign: "center", py: 3 }}>
                    <CircularProgress />
                  </Box>
                )}
              </Box>
            </PDFExport>

        </Container>
    );
}

export default VehicleInvoice2;
